// This file is part of Indico.UN.
// Copyright (C) 2019 - 2026 United Nations. All rights reserved.

// eslint-disable-next-line import/unambiguous
(function(global) {
  'use strict';
  
  global.setupUNPictureWidget = function setupUNPictureWidget(options) {
    options = $.extend(
    true,
    {
      fieldId: null,
      fieldName: null,
      capture: 'user',
      input_args: null,
    },
    options
    );
    
    function isMobileDevice() {
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4)));
    };

    let fieldId = options.fieldId;
    let fieldName = options.fieldName;

    if ( $(`#${fieldId}_upload-picture-dialog`).hasClass("ui-dialog-content") ) {
      $(`#${fieldId}_upload-picture-dialog`).dialog('destroy');
    }
    if ($(`#${fieldId}_take-picture-dialog`).hasClass("ui-dialog-content") ) {
      $(`#${fieldId}_take-picture-dialog`).dialog('destroy');
    }
    if ( $(`#${fieldId}_upload-picture-dialog.ui-dialog-content`).length > 0) {
      $(`#${fieldId}_upload-picture-dialog.ui-dialog-content`).remove();
    }
    if ( $(`#${fieldId}_take-picture-dialog.ui-dialog-content`).length > 0) {
      $(`#${fieldId}_take-picture-dialog.ui-dialog-content`).remove();
    }

    let cameraOpen = false;
    let editorActive = false;
    let cropper;
    let uploadCropper;
    let videoPlayer = document.getElementById(`${fieldId}_video-player`);
    let pictureCanvas = document.getElementById(`${fieldId}_picture-canvas`);
    let context = pictureCanvas.getContext('2d');
    let required = document.getElementById(`${fieldName}`).required;
    let dialogTitle = $t.gettext('Upload image');
    let uploadButton = $(`#${fieldId}_upload-picture`);
    let takePictureMobile = $(`#${fieldId}_take-picture-mobile`);
    let spanTitle = $t.gettext('Drop file here or click to upload');
    let spanTitleMobile = $t.gettext('Tap to capture image');
    
    if (isMobileDevice()) {
      $(`#${fieldId}_take-picture`).addClass(`${fieldId}_hidden-disabled`).prop('disabled', true);
      $(`#${fieldId}_take-picture-mobile`).removeClass(`${fieldId}_hidden-disabled`).prop('disabled', false);
    }

    let uploadPictureDialog = $(`#${fieldId}_upload-picture-dialog`).dialog({
      autoOpen: false,
      modal: true,
      title: dialogTitle,
      fluid: true,
      position: { my: "center", at: "top", of: window },
      height: 500,
      width: 500,
      open: function(event, ui) {
        resetUploadPictureDialog();
        },
      buttons: [
        {
          text: $t.gettext("Rotate left"),
          icon: 'ui-icon-arrowrefresh-1-w',
          click: function() {
            uploadCropper.rotate(45);
          }
        },
        {
          text: $t.gettext("Rotate right"),
          icon: 'ui-icon-arrowrefresh-1-w flip',
          click: function() {
            uploadCropper.rotate(-45);
          }
        },
        {
          text: $t.gettext("Save"),
          icon: "ui-icon-circle-check",
          click: function() {
            saveUploadedFile();
            resetUploadPictureDialog();
            $(this).dialog("close");
          }
        },
        {
          text: $t.gettext("Cancel"),
          icon: "ui-icon-closethick",
          click: function() {
            resetUploadPictureDialog();
            $(this).dialog("close");
          }
        }
      ]
    });
    
    uploadButton.on("click", function(e) {
      e.preventDefault();
      let pictureInput = document.getElementById(`${fieldId}_picture-upload-input`);
      if (pictureInput && pictureInput.hasAttribute("capture")) {
        pictureInput.removeAttribute("capture");
      }
      $(`#${fieldId}_picture-upload-span`).text(spanTitle);
      uploadPictureDialog.dialog("open");
    });

    takePictureMobile.on("click", function(e) {
      e.preventDefault();
      let pictureInput = document.getElementById(`${fieldId}_picture-upload-input`);
      if (pictureInput) {
        pictureInput.setAttribute("capture", capture);
      }
      $(`#${fieldId}_picture-upload-span`).text(spanTitleMobile);
      uploadPictureDialog.dialog("open");
    });

    let takePictureDialog = $(`#${fieldId}_take-picture-dialog`).dialog({
      autoOpen: false,
      modal: true,
      title: $t.gettext('Take and Edit picture'),
      fluid: true,
      position: { my: "center", at: "top", of: window },
      height: 700,
      width: 700,
      open: function(event, ui) {
        openPictureCamera();
      },
      close: function() {
        if (cameraOpen) {
          stopCamera();
        }
        $(this).dialog("close");
      },
      buttons: [
        {
          text: $t.gettext("Capture"),
          icon: "ui-icon-image",
          click: function() {
            if (cameraOpen) {
              capturePicture();
            }
          }
        },
        {
          text: $t.gettext("Retake picture"),
          icon: "ui-icon-arrowrefresh-1-s",
          click: function() {
            if (cameraOpen) {
              stopCamera();
            }
            openPictureCamera();
          }
        },
        {
          text: $t.gettext("Rotate left"),
          icon: 'ui-icon-arrowrefresh-1-w',
          click: function() {
            cropper.rotate(45);
          }
        },
        {
          text: $t.gettext("Rotate right"),
          icon: 'ui-icon-arrowrefresh-1-w flip',
          click: function() {
            cropper.rotate(-45);
          }
        },
        {
          text: $t.gettext("Save"),
          icon: "ui-icon-circle-check",
          click: function() {
            if (cameraOpen) {
              stopCamera();
            }
            saveTakePicture();
            $(this).dialog("close");
          }
        },
        {
          text: $t.gettext("Cancel"),
          icon: "ui-icon-closethick",
          click: function() {
            if (cameraOpen) {
              stopCamera();
            }
            $(this).dialog("close");
          }
        }
      ]
    });

    $(`#${fieldId}_take-picture`).on("click", function(e) { 
      e.preventDefault();
      takePictureDialog.dialog("open");
    });

    function resetVideoElement() {
      let hasVideoElement = $(`#${fieldId}_take-picture-dialog`).has("video").length;
      if (!hasVideoElement) {
        $(`#${fieldId}_take-picture-dialog`).append(`<video id='${fieldId}_video-player' autoplay playsinline></video>`);
        videoPlayer = document.getElementById(`${fieldId}_video-player`);
      }
    }

    function resetCanvasElement() {
      let hasCanvasElement = $(`#${fieldId}_take-picture-dialog`).has("canvas").length;
      if (!hasCanvasElement) {
        $(`#${fieldId}_take-picture-dialog`).append(`<canvas id='${fieldId}_picture-canvas'></canvas>`);
        pictureCanvas = document.getElementById(`${fieldId}_picture-canvas`);
        context = pictureCanvas.getContext('2d');
      }
    }

    function openPictureCamera() {
      resetTakePictureDialogButtons([$t.gettext("Capture")],
        [$t.gettext("Save"), $t.gettext("Retake picture"),
          $t.gettext("Rotate left"), $t.gettext("Rotate right")]);
      resetVideoElement();
      pictureCanvas.remove();
      $(".cropper-container").remove();
      let constraints = {
        video: {
        mandatory: {
          width: 850,
          height: 700
          }
        }
      };
      navigator.permissions.query({name: 'camera'}).then((permissionObj) => {
        if (permissionObj.state === 'denied') {
          new AlertPopup(
            $t.gettext('No access to camera'),
            $t.gettext('Please grant access to use camera in your browser settings or use the "Upload picture" button instead.')
          ).open();
        }
      });
      navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
        videoPlayer.srcObject = stream;
        cameraOpen = true;
      });
    }

    function capturePicture() {
      resetCanvasElement();
      pictureCanvas.width = 850;
      pictureCanvas.height = 700;
      context.drawImage(videoPlayer, 0, 0, pictureCanvas.width, pictureCanvas.height);
      stopCamera();
      videoPlayer.remove();
      enablePictureEditor(true);
    }

    function enablePictureEditor(enable) {
      if (enable){
        cropper = new Cropper(pictureCanvas, {
          scalable: false,
          responsive: true
        });
        resetTakePictureDialogButtons([$t.gettext("Save"), $t.gettext("Retake picture"), $t.gettext("Rotate left"), $t.gettext("Rotate right")], [$t.gettext("Capture")]);
        editorActive = true;
      } else{
        editorActive = false;
      }
    }

    function saveTakePicture() {
      if (editorActive) {
        let pictureSrc = cropper.getCroppedCanvas().toDataURL('image/jpeg');
        savePicture(pictureSrc);
      }
    }

    function resetTakePictureDialogButtons(enabledButtons, disabledButtons) {
      let buttons = takePictureDialog.dialog('option', 'buttons');
      for (let button of buttons){
        if (enabledButtons.includes(button.text)) {
          $(`#${fieldId}_take-picture-dialog + .ui-dialog-buttonpane button:contains(`+button.text+")").button().show();
        }
        if (disabledButtons.includes(button.text)) {
          $(`#${fieldId}_take-picture-dialog + .ui-dialog-buttonpane button:contains(`+button.text+")").button().hide();
        }
      }
    }

    function resetUploadPictureDialogButtons(buttons, enable) { 
      for (let button of buttons){
        if (enable) {
          $(`#${fieldId}_upload-picture-dialog + .ui-dialog-buttonpane button:contains(`+button+")").button().show();
        }
        else {
          $(`#${fieldId}_upload-picture-dialog + .ui-dialog-buttonpane button:contains(`+button+")").button().hide();
        }
      }
    }

    function stopCamera() {
      videoPlayer.srcObject.getVideoTracks().forEach(track => track.stop());
      cameraOpen = false;
    }

    $(`.${fieldId}_picture-handler-container`).on("click", `.${fieldId}_picture-drop-zone`, (e) => {
      $(`#${fieldId}_picture-upload-input`).trigger('click');
    });

    $(`.${fieldId}_picture-handler-container`).on("click", `#${fieldId}_picture-upload-input`, (e) => {
      e.stopPropagation();
    });

    $(`.${fieldId}_picture-handler-container`).on("change", `#${fieldId}_picture-upload-input`, (e) => {
      if ($(`#${fieldId}_picture-upload-input`).prop('files').length) {
        handleUpload($(`#${fieldId}_picture-upload-input`));
      }
    });

    $(`.${fieldId}_picture-handler-container`).on("dragenter dragover", `.${fieldId}_picture-drop-zone`, (e) => {
      e.preventDefault();
      $(`.${fieldId}_picture-drop-zone`).addClass(`${fieldId}_drop-zone--over`);
    });

    $(`.${fieldId}_picture-handler-container`).on("dragleave dragend", `.${fieldId}_picture-drop-zone`, (e) => {
      e.preventDefault();
      $(`.${fieldId}_picture-drop-zone`).removeClass(`${fieldId}_drop-zone--over`);
    });

    $(`.${fieldId}_picture-handler-container`).on("drop", `.${fieldId}_picture-drop-zone`, (e) => {
      e.preventDefault();
      if (e.originalEvent.dataTransfer.files.length) {
        $(`#${fieldId}_picture-upload-input`).prop('files', e.originalEvent.dataTransfer.files);
        handleUpload($(`#${fieldId}_picture-upload-input`));
      }
      $(`.${fieldId}_picture-drop-zone`).removeClass(`${fieldId}_drop-zone--over`);
    });

    function handleUpload($inputElement) {
      let sizeValidated = false;
      if ($inputElement.prop('max')) {
        sizeValidated = validateSize($inputElement);
      }
      if (sizeValidated) {
        editUploadedFile($inputElement.prop('files')[0]);
      }
    }

    function validateSize($inputElement) {
      let file = $inputElement.prop('files')[0];
      if (file.size > $inputElement.prop('max') * 1024 * 1024) {
        new AlertPopup(
          $t.gettext('File Storage'),
          $t.gettext(`The selected file is larger than the allowed size - {0} mb. Please upload a smaller file.`).format($inputElement.prop('max'))
        ).open();
        return false;
      }
      return true;
    }

    function editUploadedFile(file) {
      resetUploadPictureDialogButtons([$t.gettext("Rotate left"), $t.gettext("Rotate right"), $t.gettext("Save")], true);
      $(`.${fieldId}_picture-drop-zone`).remove();
      $(`#${fieldId}_upload-picture-dialog`).append($(`<canvas id='${fieldId}_upload-canvas'></canvas>`));
      let $uploadCanvas = document.getElementById(`${fieldId}_upload-canvas`);
      let uploadContext =  $uploadCanvas.getContext('2d');

      // Adapted from  https://stackoverflow.com/questions/10906734/how-to-upload-image-into-html5-canvas
      let image = new Image();
      image.onload = function() {
        $uploadCanvas.width = Math.min(image.width, 4000);
        $uploadCanvas.height = Math.min(image.height, 4000);
        uploadContext.drawImage(image,0,0);
        uploadCropper = new Cropper($uploadCanvas, {
          scalable: false,
          responsive: true,
          background: false,
        });
      }
      image.src = URL.createObjectURL(file);
    }

    function saveUploadedFile() {
      if (uploadCropper) {
        let pictureSrc = uploadCropper.getCroppedCanvas().toDataURL('image/jpeg');
        savePicture(pictureSrc);
      }
    }

    function savePicture(pictureSrc) {
      if ($(`.${fieldId}_picture-container img`).length === 0) {
        $(`.${fieldId}_picture-container`).append($(`<img class='ui centered small image' id='${fieldId}_image'>`));
      }
      $(`#${fieldId}_image`).attr('src', pictureSrc);
      let pictureElement = document.getElementById(fieldName);
      fetch(pictureSrc)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], 'picture.jpg', blob);
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);
          pictureElement.files = dataTransfer.files;
          pictureElement.required = false;
      });
    }

    function resetUploadPictureDialog() {
      if ($(`#${fieldId}_upload-picture-dialog canvas`).length >= 1) {
        $(`#${fieldId}_upload-picture-dialog canvas`).remove();
        $(`#${fieldId}_upload-picture-dialog .cropper-container`).remove();
      }
      if ($(`#${fieldId}_upload-picture-dialog .${fieldId}_picture-drop-zone`).length < 1) {
        $(`#${fieldId}_upload-picture-dialog`).append($(`<div class="${fieldId}_picture-drop-zone"></div>`));
        $(`#${fieldId}_upload-picture-dialog .${fieldId}_picture-drop-zone`).append($(`<input type="file" name="${fieldId}_picture-upload-input" class="${fieldId} upload-picture-input" id="${fieldId}_picture-upload-input" ${options.input_args}>`));
        $(`#${fieldId}_upload-picture-dialog .${fieldId}_picture-drop-zone`).append($(`<span id="${fieldId}_picture-upload-span" class="prompt"></span>`));
        $(`#${fieldId}_upload-picture-dialog .${fieldId}_picture-drop-zone span`).text(spanTitle);
      }
      resetUploadPictureDialogButtons([$t.gettext("Rotate left"), $t.gettext("Rotate right"), $t.gettext("Save")], false);
    }

    if (document.getElementById(`${fieldId}_metadata`).value) {
      document.getElementById(fieldName).required = false;
    }

    $(`#${fieldId}_delete`).on('click', function(event) { 
      $(`.${fieldId}_picture-container img`).remove();
      document.getElementById(`${fieldId}_deleted`).value = document.getElementById(`${fieldId}_metadata`).value;
      document.getElementById(fieldName).required = required;
      $(this).remove();
    }); 
  };
})(window);
  